<li class="stage"
    [ngClass]="{
      'current': stage.ID === currentStage?.ID,
      'completed': currentStage?.ORDER > stage.ORDER || stage.hasTransitions()
      }" *ngIf="(compact && stage.latestTransition()) || !compact">

  <div class="indicator"></div>

  <div class="info">
    <div class="stage-header">
      {{stage.NAME}}
    </div>

    <div class="date">
      <ng-container *ngIf="stage.latestTransition(); let latest;">
        {{latest.DATE | date: 'MMM dd, yy, hh:mm:ss a': 'UTC -4'}}
      </ng-container>
    </div>

  </div>

  <template #target></template>
</li>
